import { baseApi } from "../baseApi";

export const NanihalGotraApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    // CREATE
    createNanihalGotra: builder.mutation({
      query: (data) => ({
        url: "/nanihal-gotra-create",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }),
      invalidatesTags: ["NanihalGotra"],
    }),

    // GET ALL
    getNanihalGotra: builder.query({
      query: ({
        page = 1,
        limit = 10,
        search = "",
        status = "",
      } = {}) =>
        `/nanihal-gotra-list?page=${page}&limit=${limit}&search=${search}&status=${status}`,
      providesTags: ["NanihalGotra"],
    }),

    // UPDATE
    updateNanihalGotra: builder.mutation({
      query: (data) => ({
        url: "/nanihal-gotra-update",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }),
      invalidatesTags: ["NanihalGotra"],
    }),

    // STATUS CHANGE
    changeStatusNanihalGotra: builder.mutation({
      query: (id) => ({
        url: `/nanihal-gotra-status/${id}`,
        method: "GET",
      }),
      invalidatesTags: ["NanihalGotra"],
    }),

    // DELETE
    deleteNanihalGotra: builder.mutation({
      query: (id) => ({
        url: `/nanihal-gotra-delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["NanihalGotra"],
    }),

  }),
});

export const {
  useCreateNanihalGotraMutation,
  useGetNanihalGotraQuery,
  useUpdateNanihalGotraMutation,
  useDeleteNanihalGotraMutation,
  useChangeStatusNanihalGotraMutation,
} = NanihalGotraApi;